export const SESSION_CHAT_STATE_KEY = 'PDP_CHAT_STATE' as const;
